/**
 * Generated from ch1_p011.fla
 */
export function ch1_p011(this: Ich1_p011) {
	const background = this.background;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_background.call(this.background);
	background.x = 832;
	background.y = 384;
	background.width = 1664.00;
	background.height = 768.00;
	background.alpha = 1.00;
	if (background.onLayout) background.onLayout();
	const holly = this.holly;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_holly.call(this.holly);
	holly.x = 494.5;
	holly.y = 768;
	holly.width = 233.00;
	holly.height = 480.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const mom = this.mom;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_mom.call(this.mom);
	mom.x = 1145.25;
	mom.y = 768;
	mom.width = 322.50;
	mom.height = 567.00;
	mom.alpha = 1.00;
	if (mom.onLayout) mom.onLayout();
	const bubble = this.bubble;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_bubble.call(this.bubble);
	bubble.x = 820.75;
	bubble.y = 254.75;
	bubble.width = 412.50;
	bubble.height = 177.50;
	bubble.alpha = 1.00;
	if (bubble.onLayout) bubble.onLayout();
	const emojiHeart = this.emojiHeart;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheart.call(this.emojiHeart);
	emojiHeart.x = 473;
	emojiHeart.y = 107.75;
	emojiHeart.width = 83.00;
	emojiHeart.height = 94.50;
	emojiHeart.alpha = 1.00;
	if (emojiHeart.onLayout) emojiHeart.onLayout();
	const emojiHappy = this.emojiHappy;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojihappy.call(this.emojiHappy);
	emojiHappy.x = 376.5;
	emojiHappy.y = 110;
	emojiHappy.width = 98.00;
	emojiHappy.height = 94.00;
	emojiHappy.alpha = 1.00;
	if (emojiHappy.onLayout) emojiHappy.onLayout();
	const emojiKiss = this.emojiKiss;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojikiss.call(this.emojiKiss);
	emojiKiss.x = 578.5;
	emojiKiss.y = 109;
	emojiKiss.width = 97.00;
	emojiKiss.height = 93.00;
	emojiKiss.alpha = 1.00;
	if (emojiKiss.onLayout) emojiKiss.onLayout();
	const emojiParty = this.emojiParty;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiparty.call(this.emojiParty);
	emojiParty.x = 674.25;
	emojiParty.y = 102.25;
	emojiParty.width = 101.50;
	emojiParty.height = 102.50;
	emojiParty.alpha = 1.00;
	if (emojiParty.onLayout) emojiParty.onLayout();
	const emojiFrown = this.emojiFrown;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojifrown.call(this.emojiFrown);
	emojiFrown.x = 775.25;
	emojiFrown.y = 108;
	emojiFrown.width = 97.50;
	emojiFrown.height = 94.00;
	emojiFrown.alpha = 1.00;
	if (emojiFrown.onLayout) emojiFrown.onLayout();
	const emojiSad = this.emojiSad;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisad.call(this.emojiSad);
	emojiSad.x = 884.75;
	emojiSad.y = 105.75;
	emojiSad.width = 97.50;
	emojiSad.height = 93.50;
	emojiSad.alpha = 1.00;
	if (emojiSad.onLayout) emojiSad.onLayout();
	const emojiSurprise = this.emojiSurprise;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisurprise.call(this.emojiSurprise);
	emojiSurprise.x = 988.5;
	emojiSurprise.y = 111.75;
	emojiSurprise.width = 98.00;
	emojiSurprise.height = 93.50;
	emojiSurprise.alpha = 1.00;
	if (emojiSurprise.onLayout) emojiSurprise.onLayout();
	const emojiHeat = this.emojiHeat;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheat.call(this.emojiHeat);
	emojiHeat.x = 1088.5;
	emojiHeat.y = 108.75;
	emojiHeat.width = 98.00;
	emojiHeat.height = 93.50;
	emojiHeat.alpha = 1.00;
	if (emojiHeat.onLayout) emojiHeat.onLayout();
	const emojiThinking = this.emojiThinking;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojithinking.call(this.emojiThinking);
	emojiThinking.x = 1198.25;
	emojiThinking.y = 109.75;
	emojiThinking.width = 97.50;
	emojiThinking.height = 96.50;
	emojiThinking.alpha = 1.00;
	if (emojiThinking.onLayout) emojiThinking.onLayout();
	const emojiWatch = this.emojiWatch;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiwatch.call(this.emojiWatch);
	emojiWatch.x = 1294.75;
	emojiWatch.y = 104;
	emojiWatch.width = 97.50;
	emojiWatch.height = 105.00;
	emojiWatch.alpha = 1.00;
	if (emojiWatch.onLayout) emojiWatch.onLayout();
	const frame = this.frame;
	ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_wcframe.call(this.frame);
	frame.x = 832;
	frame.y = 384;
	frame.width = 1664.00;
	frame.height = 768.00;
	frame.alpha = 1.00;
	if (frame.onLayout) frame.onLayout();
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_background(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_background", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_holly(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_mom(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_mom) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_mom", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_bubble(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_bubble) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_bubble", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheart(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheart) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojiheart", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojihappy(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojihappy) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojihappy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojikiss(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojikiss) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojikiss", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiparty(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiparty) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojiparty", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojifrown(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojifrown) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojifrown", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisad(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisad) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojisad", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisurprise(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisurprise) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojisurprise", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheat(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheat) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojiheat", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojithinking(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojithinking) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojithinking", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiwatch(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiwatch) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_emojiwatch", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_wcframe(this: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_wcframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p11_wcframe", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich1_p011Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich1_p011Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich1_p011Sprite extends Ich1_p011Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich1_p011Text extends Ich1_p011Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich1_p011Polygon extends Array<number> {
}
interface Ich1_p011 {
	readonly background: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_background;
	readonly holly: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_holly;
	readonly mom: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_mom;
	readonly bubble: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_bubble;
	readonly emojiHeart: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheart;
	readonly emojiHappy: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojihappy;
	readonly emojiKiss: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojikiss;
	readonly emojiParty: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiparty;
	readonly emojiFrown: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojifrown;
	readonly emojiSad: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisad;
	readonly emojiSurprise: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisurprise;
	readonly emojiHeat: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheat;
	readonly emojiThinking: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojithinking;
	readonly emojiWatch: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiwatch;
	readonly frame: Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_wcframe;
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_background extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_holly extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_mom extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_bubble extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheart extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojihappy extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojikiss extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiparty extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojifrown extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisad extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojisurprise extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiheat extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojithinking extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_emojiwatch extends Ich1_p011Sprite {
}
interface Ich1_p011_hh_ch1_72dpi_p011012013psdAssetch1_p11_wcframe extends Ich1_p011Sprite {
}
